<template>
    <div id="pages-webhooklist">
        <AppBreadCrumb :paths="[{ title: $t('chatbotv2.addWebhook') }]" :select="true"></AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex" id="webhook-list-background">
            <div class="ml-3 mt-3" style="flex: 0 0 85%">
                <div class="big-title">{{ $t("chatbotv2.allIntegrations") }}</div>
                <div class="stories">
                    <div class="story story-add" @click="$router.push('/integrations/webhook/new')">
                        <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                        <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">{{
                            $t("chatbotv2.addWebhook")
                        }}</span>
                    </div>
                    <div
                        class="web-hook-item"
                        v-for="(webhook, index) in webhooks"
                        @click="$router.push(`/integrations/webhook/${webhook._id}/update`)"
                        :key="index"
                    >
                        <div class="icon-container">
                            <WebhookIcon />
                        </div>
                        <span
                            class="text-large font-weight-bolder mt-2 web-hook-title"
                            style="font-size: 20px; letter-spacing: 2px"
                        >
                            {{ webhook.name.toUpperCase() }}
                        </span>
                        <div class="options">
                            <a-dropdown :trigger="['click']" placement="bottomRight">
                                <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                    <span class="material-icons">more_horiz</span>
                                </div>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item>
                                            <div
                                                class="icon-container"
                                                @click="$router.push(`/integrations/webhook/${webhook._id}update`)"
                                            >
                                                <md-icon style="margin-right: 10px">edit</md-icon>
                                                <span>{{ $t("auto.webhookListEdit") }}</span>
                                            </div>
                                        </a-menu-item>
                                        <a-menu-item @click="copyChannelId(webhook._id)" style="display:flex; gap: 5px">
                                            <i class="material-icons">content_copy</i>
                                            <span>Channel ID Kopyala</span>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <div class="icon-container" @click="deleteWebhookModal(webhook._id)">
                                                <md-icon style="margin-right: 10px">delete</md-icon>
                                                <span>{{ $t("chatbotv2.delete") }}</span>
                                            </div>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import WebhookIcon from "../../Chatbot/pages/integrations/svg/WebhookIcon.vue";
import { Modal } from "ant-design-vue";
import { CHATBOT_API } from "../../../../api/chatbotv2";
import AppBreadCrumb from "../../../../components/common/AppBreadCrumb.vue";

export default {
    name: "WebhookList",
    components: { WebhookIcon, AppBreadCrumb },
    data() {
        return {
            modalVisible: false,
            webhooks: [],
        };
    },
    methods: {
        ...mapActions({
            fetchUserWebHooks: "customerWebhook/fetchUserWebHooks",
            deleteWebHook: "customerWebhook/deleteWebHook",
        }),
        copyChannelId(channelId) {
            navigator.clipboard.writeText(channelId).then(() => {
                this.$message.success("Channel ID kopyalandı");
            }).catch(() => {
                this.$message.error("Channel ID kopyalanamadı");
            });
        },
        deleteWebhookModal(id) {
            Modal.confirm({
                title: "Are you sure delete this WebHook?",
                icon: "<md-icon>exclamation</md-icon>",
                okText: "Yes",
                okType: "danger",
                cancelText: "No",
                onOk: async () => {
                    await this.deleteWebHook(id);
                    this.webhooks = this.webhooks.filter((webhook) => webhook._id !== id);
                },
                onCancel() {},
            });
        },
    },
    async mounted() {
        this.webhooks = await this.fetchUserWebHooks();
    },
};
</script>

<style lang="scss">
#pages-webhooklist {
    #webhook-list-background {
        min-height: calc(100vh - 50px) !important;
    }

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .stories {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .web-hook-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 70px;
                height: 70px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-top: 69px;
                overflow: hidden;
                position: relative;
                background: #7159c2;
                padding: 10px;
            }

            span {
                margin: 1rem 0;
                margin-top: 10px !important;
                font-weight: bold;
                display: block;
                font-size: 20px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .story-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }
}
</style>
